/**
 * Created by Ivan on 24.02.2026
 */

if (cleverapps.config.type === "merge2") {
    IslandDecorationConfig.stages = [{
        name: "stage1",
        rewards: {
            stickers2BrownPack: 1,
            mission: { amount: 200, missionType: Mission.TYPE_ISLAND_DECORATION },
            energy: 50
        },
        items: [{
            name: "item1",
            price: 100
        }, {
            name: "item2",
            price: 150
        }, {
            name: "item3",
            price: 300
        }]
    }, {
        name: "stage2",
        rewards: {
            stickers2BrownPack: 1,
            mission: { amount: 300, missionType: Mission.TYPE_ISLAND_DECORATION },
            unit: [
                { code: "ff", stage: 4, amount: 1 }
            ]
        },
        items: [{
            name: "item4",
            price: 250
        }, {
            name: "item5",
            price: 350
        }, {
            name: "item6",
            price: 500
        }]
    }, {
        name: "stage3",
        rewards: {
            stickers2GreenPack: 1,
            mission: { amount: 400, missionType: Mission.TYPE_ISLAND_DECORATION },
            unit: [
                { code: "Cf", stage: 0, amount: 1 }
            ]
        },
        items: [{
            name: "item7",
            price: 400
        }, {
            name: "item8",
            price: 500
        }, {
            name: "item9",
            price: 650
        }]
    }, {
        name: "stage4",
        rewards: {
            stickers2GreenPack: 1,
            mission: { amount: 500, missionType: Mission.TYPE_ISLAND_DECORATION },
            energy: 100
        },
        items: [{
            name: "item10",
            price: 500
        }, {
            name: "item11",
            price: 650
        }, {
            name: "item12",
            price: 800
        }]
    }, {
        name: "stage5",
        rewards: {
            stickers2BluePack: 1,
            mission: { amount: 600, missionType: Mission.TYPE_ISLAND_DECORATION },
            unit: [
                { code: "ff", stage: 5, amount: 1 }
            ]
        },
        items: [{
            name: "item13",
            price: 750
        }, {
            name: "item14",
            price: 900
        }, {
            name: "item15",
            price: 1000
        }]
    }, {
        name: "stage6",
        rewards: {
            stickers2VioletPack: 1,
            mission: { amount: 800, missionType: Mission.TYPE_ISLAND_DECORATION },
            energy: 150
        },
        items: [{
            name: "item16",
            price: 900
        }, {
            name: "item17",
            price: 1100
        }, {
            name: "item18",
            price: 1400
        }]
    }, {
        name: "stage7",
        rewards: {
            stickers2RedPack: 1,
            unit: [
                { code: "rr", stage: 3, amount: 1 },
                { code: "ff", stage: 6, amount: 1 }
            ]
        },
        items: [{
            name: "item19",
            price: 1900
        }, {
            name: "item20",
            price: 2400
        }, {
            name: "item21",
            price: 3500
        }]
    }];

    IslandDecorationConfig.stages.forEach((stage, stageId) => {
        stage.id = stageId;

        stage.items.forEach((item, itemId) => {
            item.id = itemId;
            item.stage = stageId;
        });
    });

    RewardsConfig.IslandDecorationReward = {
        unit: [
            { code: "qq", stage: 2, amount: 1 },
            { code: "ff", stage: 4, amount: 1 }
        ],
        energy: 100
    };

    IslandDecorationConfig.calcOrderReward = (order) => {
        let sum = 0;

        order.ingredients.forEach((ingredient) => {
            const unit = ingredient.unit;
            let amount = 0;

            if (unit.code === "a" || unit.code === "c") {
                amount = 1.004 * Math.pow(unit.stage, 2) - 4.7153 * unit.stage + 5.5245;
            } else {
                amount = 0.961 * Math.pow(unit.stage, 2) - 1.2458 * unit.stage + 0.6364;
            }

            amount = Math.round(amount / 5) * 5;

            if (amount >= 5) {
                sum += amount;
            }
        });

        return sum;
    };
}
